import { Directive,ElementRef,HostListener } from '@angular/core';

@Directive({
  selector: '[appNoBrackets]'
})
export class NoBracketsDirective {

  constructor(private ele:ElementRef) { }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete'];
    const inputChar = event.key;
    const hasAngleBrackets = inputChar.includes('<') || inputChar.includes('>');

    if (hasAngleBrackets && !allowedKeys.includes(inputChar)) {
      event.preventDefault();
    }
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3074433461/src/src/app/shared/directive/no-brackets.directive.ts